export const TEXT_TRANSFORM_TITLE_CASE = 'titleCase';
export const TEXT_TRANSFORM_UPPER_CASE = 'upperCase';
export const TEXT_TRANSFORM_LOWER_CASE = 'lowerCase';

export const MARK_TEXT_TRANSFORM = 'textTransform';
